import { formatDate } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { ParameterTypesEnum } from '../enums/parameter-types.enum';
import { UiService } from '../services/ui.service';

@Pipe({
  name: "biggerPictureDate",
})
export class BiggerPictureDatePipe implements PipeTransform {
  constructor(private uiService: UiService) {}

  transform(value: any, format: string = "shortDate") {
    if (!value) return "";

    const tempValue = typeof value === "string" ? value.replace(/\s/g, "T") : value;
    const res = formatDate(tempValue, format, this.uiService.locale);
    return res.includes(".")
      ? res.split(".").join(this.uiService.parametersMap.get(ParameterTypesEnum.DATE_SEPARATOR).data)
      : res.split("/").join(this.uiService.parametersMap.get(ParameterTypesEnum.DATE_SEPARATOR).data);
  }
}
